<template>
    <div class="contain">
      <div class="header">
        {{ $t('transferInto.lang')}}
      </div>
      <div class="card-box" v-for="(item,index) in bankList" :key="item.id" :class="{'first':index == 0}" @click="jumpToBankDetail(item)">
        <div class="info">
          <div class="img-box">
            <img :src="item.bank_img" class="bank-logo" />
          </div>
          <div class="content">
            <div class="title">
              {{ item.receiver_bank_cn }}
            </div>
            <div class="tip">
              {{ $t('transferInto.lang0') }}
            </div>
          </div>
          <div class="icon-right">
            <img :src="bgColor == 'black-theme' ? darkRight : arrowRight" class="right-icon" />
          </div>
        </div>
        <div class="text">
          <span>{{ $t('mki18n.t00021') }}</span>
          <span v-if="item.fps_code">、FPS</span>
        </div>
      </div>
    </div>
</template>

<script>
  import arrowRight from '@/assets/images/app-pages/arrow-right.png'
  import darkRight from '@/assets/images/app-pages/darkRight.png'
  import { Toast } from "vant";
  export default {
    data(){
      return{
        arrowRight,
        darkRight,
        bankList:[]
      }
    },
    created() {
      this.init()
    },
    computed: {
      bgColor() {
        return this.$store.getters["common/bgColor"];
      }
    },
    methods:{
      init(){
        this.$apis.geRemittanceList({ account_type: this.$route.query.account_type }).then(res => {
           if (res) {
             this.bankList = res;
           }
        });
      },
      jumpToBankDetail(item) {
        const toastLoading = Toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: "spinner",
          message: this.$t("common.loading_text")
        });
        this.$router.push({
          path: "/app-pages/transfer-into-abroad",
          query: { ...this.$route.query, id: item.id }
        }).finally(() =>{
          toastLoading.clear()
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .header{
    padding: 24px 32px;
    font-size: 32px;
    font-weight: 500;
    color: #17161c;
  }
  .card-box{
    background: #f6f7fa;
    border-radius: 24px;
    margin: 24px 32px;
    padding: 40px 32px 25px;
    &.first{
      margin-top: -6px;
    }
    .info{
      display: flex;
    }
    .text{
      margin-top: 40px;
      padding-top: 20px;
      border-top: rgba(116,115,119,.1) solid 1px;
      color: #747377;
      font-size: 26px;
    }
    .img-box{
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;
      width: 88px;
      height: 88px;
      background: #ffffff;
      border-radius: 100%;
      .bank-logo{
        width: 68px;
        height: 68px;
        object-fit: contain;
      }
    }
    .content{
      margin-left: 16px;
      .title{
        font-size: 32px;
        font-weight: 500;
        color: #17161c;
      }
      .tip{
        font-size: 28px;
        font-weight: 400;
        color: #747377;
      }
    }
    .icon-right{
      flex: 1;
      display: flex;
      align-items: center;
      text-align: right;
      justify-content: flex-end;
      .right-icon{
        width: 48px;
        height: 48px;
      }
    }
  }
  .black-theme{
    .header{
      color: #FFFFFF;
    }
    .card-box{
      background: #0A0B0F;
      .content{
        .title{
          color: #FFFFFF;
        }
        .tip{
          color: #9D9D9F;
        }
      }
    }
  }
</style>
